import React, { useState } from 'react';
import { ViewType } from '../../types';
import ProactiveDashboard from './ProactiveDashboard';
import StudioEditor from './StudioEditor';

interface StudioHubProps {
  userId: string;
  onNavigate?: (view: ViewType) => void;
}

const StudioHub: React.FC<StudioHubProps> = ({ userId, onNavigate }) => {
  const [currentView, setCurrentView] = useState<'dashboard' | 'editor'>('dashboard');
  const [selectedProject, setSelectedProject] = useState<string | null>(null);

  const handleProjectSelect = (projectId: string) => {
    setSelectedProject(projectId);
    setCurrentView('editor');
  };

  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
    setSelectedProject(null);
  };

  if (currentView === 'editor') {
    return <StudioEditor onBack={handleBackToDashboard} />;
  }

  return (
    <div>
      <ProactiveDashboard onProjectSelect={handleProjectSelect} />
    </div>
  );
};

export default StudioHub;
